import React, { useRef, useState, useEffect } from 'react';
import { Layout, Menu, Button } from 'antd';
import {
    CImg,
    CLink
} from '@coreui/react'
import './index.scss'
import { DownloadOutlined, LockOutlined } from '@ant-design/icons';
import { Container } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { WEB_OPEN_ID, WEBSITE_URL } from '../../env';
import { template } from 'lodash';
import ApiContent from '../../api/ApiContent';
import CSwl from '../../utils/alert';
import "quill/dist/quill.snow.css";
const logo = require('./../../assets/icons/law-beta_version-02_20210507.svg');
const doc = require('./../../assets/icons/doc.svg');
const content = require('./../../assets/icons/content.svg');
const question = require('./../../assets/icons/question.svg');
// const bottom1 = require('./../../assets/icons/bottom-1.png');
const bottom1 = require('./../../assets/icons/OCS_New_Logo_with_Texts_no_motto.jpg');
const bottom2 = require('./../../images/logoDGA_NEW.png');
const faqDoc = require('../../templates/ระบบกลาง_[FAQ] สำหรับหน่วยงาน_06.pdf')
const faqManaul = require('../../templates/ระบบกลาง_[คู่มือการใช้งาน] สำหรับหน่วยงาน_213.pdf')
const { Header, Content, Footer, Sider } = Layout;
const First = () => {
    const [displayScreen, setdisplayScreen] = useState(1);
    const history = useHistory();
    const section1 = useRef(null)
    const section2 = useRef(null)
    const section3 = useRef(null)
    const section4 = useRef(null)
    const section5 = useRef(null)
    const section6 = useRef(null)
    const [dataContent, setdataContent] = useState({
        news: {},
        faq: {},
        doc: {},
        termcondition: {},
        policy: {}
    });

    useEffect(() => {
        getData();
        return () => {
        }
    }, [])

    const executeScroll1 = () => section1.current.scrollIntoView({ behavior: 'smooth', inline: "nearest" })
    const executeScroll2 = () => {
        const node = section2.current;
        var yourHeight = 90;
        // scroll to your element
        node.scrollIntoView(true);
        // now account for fixed header
        const scrolledY = window.scrollY;
        if (scrolledY) {
            window.scroll({ top: scrolledY - yourHeight, left: 0, behavior: 'smooth' });
        }
    }
    const executeScroll3 = () => {
        const node = section3.current;
        var yourHeight = 90;
        // scroll to your element
        node.scrollIntoView(true);
        // now account for fixed header
        const scrolledY = window.scrollY;
        if (scrolledY) {
            window.scroll({ top: scrolledY - yourHeight, left: 0, behavior: 'smooth' });
        }
    }
    const executeScroll4 = () => {
        const node = section4.current;
        var yourHeight = 90;
        // scroll to your element
        node.scrollIntoView(true);
        // now account for fixed header
        const scrolledY = window.scrollY;
        if (scrolledY) {
            window.scroll({ top: scrolledY - yourHeight, left: 0, behavior: 'smooth' });
        }
    }
    const executeScroll5 = () => {
        const node = section5.current;
        var yourHeight = 90;
        // scroll to your element
        node.scrollIntoView(true);
        // now account for fixed header
        const scrolledY = window.scrollY;
        if (scrolledY) {
            window.scroll({ top: scrolledY - yourHeight, left: 0, behavior: 'smooth' });
        }
    }
    const executeScroll6 = () => {
        const node = section6.current;
        var yourHeight = 90;
        // scroll to your element
        node.scrollIntoView(true);
        // now account for fixed header
        const scrolledY = window.scrollY;
        if (scrolledY) {
            window.scroll({ top: scrolledY - yourHeight, left: 0, behavior: 'smooth' });
        }
    }

    const downloadManual = () => {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', dataContent.doc?.file_url);
        link.setAttribute('download', `ระบบกลาง_[คู่มือการใช้งาน] สำหรับหน่วยงาน_213.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
    const downloadFAQ = () => {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', dataContent.faq?.file_url);
        link.setAttribute('download', `ระบบกลาง_[FAQ] สำหรับหน่วยงาน_06.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    const getData = async () => {
        try {
            CSwl.SwalLoad();
            const result = await ApiContent.get();
            if (result.status === 200) {
                const news = result.data.data.find((x) => x.type == "news");
                const faq = result.data.data.find((x) => x.type == "faq_backend");
                const doc = result.data.data.find((x) => x.type == "doc_backend");
                const policyresult = result.data.data.find((x) => x.type == "privacypolicy_be");
                const term = result.data.data.find((x) => x.type == "termcondition_be");
                setdataContent({ news: news, faq: faq, doc: doc, termcondition: term, policy: policyresult });
            }
            CSwl.SwalClose();
            // CSwl.SwalInfo(`เพื่อเพิ่มประสิทธิภาพในการใช้งาน ระบบกลางทางกฎหมายขอแจ้งปิดปรับปรุง ในวันที่ 3 ก.พ. เวลา 20.00 น. ถึงวันที่ 4 ก.พ. เวลา 02.00 น.โดยจะไม่สามารถเข้าใช้งานได้ในช่วงเวลาดังกล่าวขออภัยในความไม่สะดวกมา ณ โอกาสนี้`)
        } catch (error) {
            CSwl.SwalClose();
        }
    };

    return (
        <div id="first-page" ref={section1}>
            <div className="header">
                <div>
                    <CImg width={200} src={logo} />
                </div>
                <div className="flex-1 d-flex right-menu">
                    <label onClick={() => {
                        setdisplayScreen(1)
                    }}>หน้าหลัก</label>
                    <label onClick={() => {
                        setdisplayScreen(2)
                    }}>Terms and condition</label>
                    <label onClick={() => {
                        setdisplayScreen(3)
                    }}>Privacy Notice</label>
                    <label onClick={executeScroll3}>คู่มือ</label>
                    <label onClick={executeScroll4}>ที่มา</label>
                    <label onClick={executeScroll5}>FAQ</label>
                    <label onClick={executeScroll6}>ติดต่อเรา</label>
                    <CLink
                        target={'_blank'}
                        href={WEB_OPEN_ID}
                        style={{ fontWeight: 'bold', color: '#275394', textDecoration: 'underline' }} to="">
                        ลงทะเบียนผู้ใช้ใหม่
                    </CLink>
                    <Button
                        onClick={() => {
                            //history.push('/login')
                            window.location.href = WEB_OPEN_ID;
                        }}
                        className="d-flex-center"
                        style={{ background: '#275394', display: 'flex', color: '#fff', padding: 20, borderRadius: 10, marginLeft: 20 }}
                        icon={<LockOutlined />}>
                        เข้าสู่ระบบ
                    </Button>
                </div>
            </div>
            {
                displayScreen == 1 && <Container className="d-flex-center flex-column" style={{ paddingTop: 90, display: 'flex' }}>
                    {dataContent.news &&
                        <div className="d-flex mt-5 d-flex-center flex-column" style={{ background: '#fff', padding: '20px 30px', width: '90%' }}>
                            <label className="title">ข่าวสาร</label>
                            <div className="d-flex-center p-4 content w-100" >
                                <span dangerouslySetInnerHTML={{ __html: dataContent.news?.content }} />
                            </div>
                        </div>
                    }

                    <div ref={section2} className="d-flex mt-5">
                        <div className="d-flex flex-column">
                            <label className="title">แนวทางปฏิบัติ</label>
                            <label style={{ whiteSpace: 'pre-line' }}>{`เมื่อหน่วยงาน ได้รับหนังสือขอความร่วมมือและแจ้งแนวทางปฏิบัติ
            เกี่ยวกับระบบกลางทางกฎหมาย`}</label>
                        </div>
                        <div className="d-flex-center"
                            style={{ padding: 30, background: '#fff', borderRadius: '50%', marginLeft: 20 }}>
                            <CImg height={60} src={doc} />
                        </div>
                    </div>
                    <div ref={section3} className="d-flex mt-5 d-flex-center" style={{ background: '#fff', padding: '20px 30px', width: '90%' }}>
                        <div className="d-flex flex-column mr-5">
                            <CImg className="mb-4" height={60} src={content} />
                            {/* <span>ศึกษาขั้นตอน <span>การใช้งานระบบกลางทางกฎหมาย Backend</span></span>
            <span>เพื่อขอรับบัญชีผู้ใช้งาน และวิธีเข้าใช้งานระบบ</span> */}
                            {
                                <span dangerouslySetInnerHTML={{ __html: dataContent.doc?.content }} />
                            }
                            <Button
                                onClick={downloadManual}
                                className="d-flex-center mt-3"
                                style={{ background: '#275394', display: 'flex', color: '#fff', padding: 20, borderRadius: 10, marginLeft: 20 }}
                                icon={<DownloadOutlined />}>
                                ดาวน์โหลดเอกสาร
                            </Button>
                        </div>
                        <div className="d-flex">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/videoseries?list=PL7j_ArJegESb6jLXfroiGGxh2GPvj-y82" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                    <div ref={section4} className="d-flex mt-5 d-flex-center flex-column" style={{ background: '#fff', padding: '20px 30px', width: '90%' }}>
                        <label className="title">ที่มาโครงการ</label>
                        <div className="d-flex-center p-4 content" >
                            <span>ด้วยพระราชบัญญัติการอำนวยความสะดวกในการพิจารณาอนุญาตของทางราชการ พ.ศ. ๒๕๕๘ และมติคณะรัฐมนตรี เมื่อวันที่ ๗ มกราคม ๒๕๖๓ เรื่อง รายงานผลการดำเนินงานตามแผนยกระดับการบริการภาครัฐ ระยะที่ ๒ ตามพระราชบัญญัติการอำนวยความสะดวกในการพิจารณาอนุญาตของทางราชการ พ.ศ. ๒๕๕๘ เพื่อเป็นการอำนวยความสะดวกแก่ประชาชน ให้ได้รับการบริการจากภาครัฐที่รวดเร็ว ง่าย และลดภาระค่าใช้จ่าย โดยให้หน่วยงานราชการดำเนินการพัฒนาปรับปรุงการทำงานภายในหน่วยงานให้มีประสิทธิภาพมากยิ่งขึ้น และให้ได้รับรู้ความพึงพอใจจากการใช้บริการของประชาชน โดยสำนักงานคณะกรรมการพัฒนาระบบราชการ และสำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน) หรือ สพร. ได้ร่วมมือพัฒนาระบบกลางกฎหมาย ซึ่งเป็นเครื่องมือในการให้ข้อมูลจุดให้บริการประชาชน ทั้งพิกัดจุดให้บริการ และรายละเอียดของงานบริการ เพื่อให้ผู้เข้ารับบริการสามารถเข้าถึงและรับรู้ช่องทางการให้บริการภาครัฐได้อย่างสะดวกรวดเร็ว และเป็นเครื่องมือในการแสดงความพึงพอใจการใช้บริการของหน่วยงานราชการ ณ จุดบริการโดยการสแกน QR Code เพื่อให้ผู้เข้ารับบริการสามารถมีส่วนร่วมในการให้ผลตอบรับจากการเข้าถึงช่องทางการให้บริการภาครัฐ และนำไปสู่การต่อยอดเป็นเครื่องมือในการรับรู้ความคาดหวังและความพึงพอใจของประชาชนผู้ใช้งานมากขึ้นต่อไป</span>
                        </div>
                    </div>
                    <div ref={section5} className="d-flex mt-5 d-flex-center" style={{ background: '#fff', padding: '20px 30px', width: '90%' }}>
                        <div className="d-flex flex-column">
                            <CImg className="mb-4" height={60} src={question} />
                            <label className="title">คำถามที่พบบ่อย (FAQ)</label>
                            <span dangerouslySetInnerHTML={{ __html: dataContent.faq?.content }} />
                            <Button
                                onClick={downloadFAQ}

                                className="d-flex-center mt-3"
                                style={{ background: '#275394', display: 'flex', color: '#fff', padding: 20, borderRadius: 10, marginLeft: 20, fontSize: 16 }}
                                icon={<DownloadOutlined />}>
                                ดาวน์โหลดเอกสาร
                            </Button>
                        </div>
                    </div>
                    <div className="d-flex mt-5 d-flex-center" style={{ width: '90%' }}>
                        <CImg className="mr-5" height={70} src={bottom1} />
                        <CImg className="ml-5" height={60} src={bottom2} />
                    </div>
                    <div style={{ height: 50, width: '100%' }}></div>
                </Container>
            }
            {displayScreen == 2 && <Container className="d-flex-center flex-column" style={{ paddingTop: 90, display: 'flex' }}>
                {dataContent.termcondition &&
                    <div className="d-flex mt-5 d-flex-center flex-column" style={{ background: '#fff', padding: '20px 30px', width: '90%' }}>
                        <label className="title">{dataContent.termcondition?.title}</label>
                        <div className="d-flex-center p-4 content w-100 contact-description ql-editor" >
                            <span dangerouslySetInnerHTML={{ __html: dataContent.termcondition?.content }} />
                        </div>
                    </div>
                }
            </Container>
            }
            {displayScreen == 3 && <Container className="d-flex-center flex-column" style={{ paddingTop: 90, display: 'flex' }}>
                {dataContent.policy &&
                    <div className="d-flex mt-5 d-flex-center flex-column" style={{ background: '#fff', padding: '20px 30px', width: '90%' }}>
                        <label className="title">{dataContent.policy?.title}</label>
                        <div className="d-flex-center p-4 content w-100 contact-description ql-editor" >
                            <span dangerouslySetInnerHTML={{ __html: dataContent.policy?.content }} />
                        </div>
                    </div>
                }
            </Container>
            }
            <div ref={section6} style={{ marginBottom: 20 }}>
                <div className="flex-1 d-flex-center flex-column">
                    <span style={{ fontSize: 20 }}>ติดต่อเรา</span>
                    <div className="d-flex mt-3" style={{ justifyContent: 'space-between' }}>
                        <div className="mr-4 ml-4">
                            <span>สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน) สพร. หรือ DGA <CLink target={'_blank'} href="https://www.dga.or.th">{'https://www.dga.or.th'}</CLink></span>
                        </div>
                    </div>
                </div>
            </div>
            <div ref={section6} className="footer-top">
                <div className="flex-1 d-flex-center flex-column">
                    <span style={{ fontSize: 20 }}>ติดต่อสอบถาม</span>
                    <div className="d-flex mt-3" style={{ justifyContent: 'space-between' }}>
                        <div className="mr-4 ml-4">
                            <span>โทรศัพท์ : (+66) 2612 6060</span>
                        </div>
                        <div className="mr-4 ml-4">
                            <span>โทรสาร : (+66) 2612 6011-12</span>
                        </div>
                        <div className="mr-4 ml-4">
                            <span>อีเมล : contact@dga.or.th</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer">
                <div className="flex-1 d-flex-center">
                    <span>สงวนลิขสิทธิ์ พ.ศ. 2564 ตามพระราชบัญญัติลิขสิทธิ์ 2537 สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน) (สพร.)</span>
                </div>
            </div>

        </div >
    )
}
export default First
